import { SEVEN_STEPS } from "@/data/content";
import Reveal from "./Reveal";

const SevenSteps = ({ detailed = false }) => (
  <ol data-testid="seven-steps" className="relative grid gap-5 sm:grid-cols-2 xl:grid-cols-4">
    {SEVEN_STEPS.map((step, i) => (
      <Reveal as="li" key={step.n} delay={i * 0.06}>
        <div
          data-testid={`seven-step-${step.n}`}
          className="group h-full rounded-2xl bg-white p-6 border border-slate-100 shadow-[0_8px_30px_rgb(0,0,0,0.05)] hover:shadow-[0_12px_40px_rgb(7,91,89,0.12)] hover:-translate-y-1 transition-all duration-300"
        >
          <div className="flex items-center gap-3">
            <span
              className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full font-display text-lg font-bold text-white transition-transform duration-300 group-hover:scale-110"
              style={{ backgroundColor: step.color }}
            >
              {step.n}
            </span>
            <h3 className="font-display font-semibold text-brand-charcoal leading-snug">{step.title}</h3>
          </div>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">{step.short}</p>
          {detailed && (
            <ul className="mt-3 space-y-1.5 border-t border-slate-100 pt-3">
              {step.points.map((p) => (
                <li key={p} className="flex gap-2 text-xs text-slate-500 leading-relaxed">
                  <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full" style={{ backgroundColor: step.color }} />
                  {p}
                </li>
              ))}
            </ul>
          )}
        </div>
      </Reveal>
    ))}
  </ol>
);

export default SevenSteps;
